export const parseSearchInput = (input = '') => {
  const trimmedInput = input.trim();
  const channelIdMatch = trimmedInput.match(/channelId:([^\s]+)/i);

  if (!channelIdMatch) {
    return { query: trimmedInput, channelId: '' };
  }

  const matchedValue = channelIdMatch[0];
  const extractedChannelId = channelIdMatch[1];
  const beforeMatch = trimmedInput.slice(0, channelIdMatch.index);
  const afterMatch = trimmedInput.slice(channelIdMatch.index + matchedValue.length);
  const remainingQuery = `${beforeMatch} ${afterMatch}`.replace(/\s+/g, ' ').trim();

  return {
    query: remainingQuery,
    channelId: extractedChannelId,
  };
};
